module.exports = __webpack_public_path__ + "img/about_num1.f15e3a1.png";